<script setup lang="ts">

import AppleButton from "@/components/AppleButton.vue";
import FacebookButton from "@/components/FacebookButton.vue";
import BottomSheet from "@/components/modal/BottomSheet.vue";
import { Capacitor } from "@capacitor/core";
import { ref } from "vue";
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
const isIOS = Capacitor.getPlatform() === "ios";

const loginSheet = ref(null);
const loginTitle = ref(t('choose.language.logIn'));
const loginDescription = ref(null);

const emit = defineEmits(['login']);

const onLogin = () => close();

const close = () => loginSheet.value?.close()

const open = (title, description) => {
    loginTitle.value = title ?? t('choose.language.logIn');
    loginDescription.value = description ?? null

    loginSheet.value?.open()
}

defineExpose({
    open,
    close
})
</script>

<template>
    <bottom-sheet ref="loginSheet">
        <template #default>
            <div class="p-4">
                <h1 class="text-center text-white font-bold">{{ loginTitle }}</h1>
                <p v-if="loginDescription" class="text-center text-white my-4">{{ loginDescription }}</p>

                <div class="flex flex-col items-stretch my-8 gap-6">
                    <facebook-button @login="onLogin()">
                        {{ $t('settings.sign.in.facebook.button') }}
                    </facebook-button>

                    <apple-button v-if="isIOS" @login="onLogin()">
                        {{ $t('settings.sign.in.apple.button') }}
                    </apple-button>
                </div>
            </div>
        </template>
    </bottom-sheet>
</template>

<style scoped lang="scss">

</style>
